import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    fieldAndButtonLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gap: theme.spacing(1),
    },
  };
};
